import React, { useState, useEffect, useRef } from "react";
import { PoolDetails, Row, Footer } from "./style";
import PoolTvlParticipants from "../PoolTvlParticipants";
import {
  lockEnd,
  yourWeightage,
} from "../../../common/BPADBlockStakeContract";
import { useSelector } from "react-redux";
import PoolTimer from "./PoolTimer";
import { getBalanceNumber } from "../../../utils/formatBalance";
import { getChainDataByChainId } from "../../../utils";
import { MINIMUM_LOCK } from "../../../constants";

function PoolDetail() {
  const [showLockendWeightage, setShowLockendWeightage] = useState(false);
  const [LockEnd, setLockEnd] = useState("");
  const [yourWeightAge, setYourWeightAge] = useState(1.02);
  const [href, setHref] = useState("");
  const [buyHref, setBuyHref] = useState("#");
  const lockId = useRef(null);
  const { networkIdFromURL } = useSelector(
    (state) => state.global
  );
  const { corePoolContract, projectNamePoolName } =
    useSelector((state) => state.global);
  const { rewardAddress } = useSelector(
    (state) => state.global.poolAddresses
  );
  const { rewardDecimal } = useSelector(
    (state) => state.global.rewardDecimalPoolTokenDecimal
  );
  const { poolTknSymbol, rewardTknSymbol } = useSelector(
    (state) => state.global.tknSymbol
  );
  const { startBlock, endBlock, rewardTokenPerBlock } = useSelector(
    (state) => state.global.poolDetailsFromFactory
  );
  const {
    APY,
    balanceOfTvl,
    totalStake,
    totalStakevalue
  } = useSelector(
    (state) => state.global.actionBasedData
  )

  useEffect(async () => {
    if(corePoolContract) {
      const YourWeightAge = await yourWeightage(corePoolContract);
      setYourWeightAge(YourWeightAge);
    }   
  }, [corePoolContract, totalStake]);

  const realtimeLock = async () => {
    //TODO: remove every minute call
    const Lockend = await lockEnd(corePoolContract);
    if (Lockend > 0) {
      setLockEnd(Lockend);
    }
  };

  const endBlock_LockEnd_Weightage = async () => {
    if (totalStake <= 0 || isNaN(totalStake)) {
      clearInterval(lockId.current);
      setShowLockendWeightage(false);
    } else {
      setShowLockendWeightage(true);
      lockId.current = setInterval(() => {
        realtimeLock();
      }, [60000]);
    }
  };

  useEffect(async () => {
    if (totalStake && corePoolContract) {
      if (!isNaN(totalStake)) {
        await realtimeLock()
      }
      endBlock_LockEnd_Weightage();
    }
  }, [totalStake, corePoolContract]);

  useEffect(() => {
    let chainData = getChainDataByChainId(networkIdFromURL)
    setHref(`${chainData?.url}address/${rewardAddress}`);
    setBuyHref(`${chainData?.dex}/swap?inputCurrency=0x55d398326f99059fF775485246999027B3197955&outputCurrency=0xd5e950837Ad48D08baD2f87bFcF8eD7167bB44BC`)
  }, [networkIdFromURL, rewardAddress]);


  const getRewardPerWeek = function(rewardTokenPerBlock) {
    let oneBlockTime = getChainDataByChainId(networkIdFromURL).blockTime
    let blockInDay = (60 * 60 * 24) / oneBlockTime
    return 7 * blockInDay * rewardTokenPerBlock
  }

  return (
    <PoolDetails>
      <PoolTvlParticipants
        large={false}
        label1="TVL"
        value1={
          balanceOfTvl && poolTknSymbol
            ? balanceOfTvl + " " + poolTknSymbol
            : poolTknSymbol === undefined
              ? 0
              : 0 + " " + poolTknSymbol
        }
        lable2="Participants"
        value2={totalStakevalue}
      />
      <div className="flexColumn ">
        <Row>
          <p className="key">Est. APY</p>
          <p>
            {!isNaN(APY) || APY !== undefined
              ? APY === "Infinity"
                ? projectNamePoolName?.pool_initial_apy + "%"
                : APY == "null"
                  ? 0 + "%"
                  : APY + "%"
              : 0 + "%"}
          </p>
        </Row>
        <Row>
          <p className="key">Reward per week</p>
          <p>
            {rewardTokenPerBlock && rewardTknSymbol
              ? (
                getRewardPerWeek(getBalanceNumber(rewardTokenPerBlock, rewardDecimal, 18))
              ).toFixed(2) +
              " " +
              rewardTknSymbol
              : 0}
          </p>
        </Row>
        {showLockendWeightage ? (
          <Row>
            <p className="key">End block</p>
            <p><a href={networkIdFromURL && (getChainDataByChainId(networkIdFromURL).url + "block/" + endBlock)} target="_blank">{endBlock ? endBlock : 0}</a></p>
          </Row>
        ) : (
          <Row>
            <p className="key">Start block</p>
            <p>{startBlock ? startBlock : 0}</p>
          </Row>
        )}
        {showLockendWeightage ? (
          <Row>
            <p className="key">Lock ends</p>
            <p>
              {LockEnd
                ? parseInt(LockEnd / 86400) +
                " " +
                "Days" +
                " " +
                parseInt((LockEnd % 86400) / 3600) +
                " " +
                "Hours" +
                " " +
                parseInt(((LockEnd % 86400) % 3600) / 60) +
                " " +
                "Minutes"
                : 0 +
                " " +
                "Days" +
                " " +
                0 +
                " " +
                "Hours" +
                " " +
                0 +
                " " +
                "Minutes"}
            </p>
          </Row>
        ) : (
          <Row>
            <p className="key">End block</p>
            <p><a href={networkIdFromURL && (getChainDataByChainId(networkIdFromURL).url + "block/" + endBlock)} target="_blank">{endBlock ? endBlock : 0}</a></p>
          </Row>
        )}
        {showLockendWeightage ? (
          <Row>
            <p className="key">Your weightage</p>
            <p>{yourWeightAge}x</p>
          </Row>
        ) : (
          <Row>
            <p className="key">Minimum lock</p>
            <p>{MINIMUM_LOCK / 86400} Days</p>
          </Row>
        )}
      </div>

      <div className="flexColumn margin">
        <p className="poolDuration">Est. Pool Duration</p>
        <PoolTimer />
        <Footer className="flex sectionFooter">
          <a href={buyHref} target="#">
            {rewardTknSymbol !== undefined
              ? "Buy " + rewardTknSymbol
              : "Buy "}
          </a>
          <a href={href} target="#">
            {rewardTknSymbol !== undefined
              ? rewardTknSymbol + " Contract Address"
              : "Contract Address"}
          </a>
        </Footer>
      </div>
    </PoolDetails>
  );
}

export default PoolDetail;
